module.exports = __webpack_public_path__ + "img/RGB_aI_3.jpg";